module.exports = require("./slick/slick.js");
require("./slick/slick.css");


//////////////////
// WEBPACK FOOTER
// slick-carousel (bower component)
// module id = 495
// module chunks = 1